import type { ClaimValue } from './claimValue';

export type WastewaterIntroState =
  | 'combined_same_year_in_total'
  | 'combined_scaled_other_year_in_total'
  | 'separate_same_year_in_total'
  | 'available_same_year_not_in_total'
  | 'available_different_year_not_in_total'
  | 'unavailable'
  | 'unresolved_or_conflicting';

export type IntroductionBlockId =
  | 'purpose'
  | 'about'
  | 'scope'
  | 'headline'
  | 'methods'
  | 'interpret';

export type QuantitativeFindingId = 'transport_vs_buildings' | 'historical_software_series' | 'dominant_source_numeric';

export type QualitativeFindingId =
  | 'boundary_unresolved'
  | 'unusual_denominator'
  | 'dominant_source_qualitative';

export interface IntroFinding {
  id: QuantitativeFindingId | QualitativeFindingId;
  kind: 'quantitative' | 'qualitative';
  copyKey: string;
  text: string;
}

export interface ScopeBoxRow {
  id: string;
  label: string;
  value: string;
}

export interface IntroductionView {
  jurisdictionName: string;
  geofips: number | null;
  inventoryYear: number;
  accountingLensLabel: 'Community inventory';
  blocksRendered: IntroductionBlockId[];
  purposeParagraphs: string[];
  aboutParagraphs: string[];
  scopeParagraphs: string[];
  headlineParagraphs: string[];
  methodsParagraphs: string[];
  interpretParagraphs: string[];
  footnotes: string[];
  scopeBoxRows: ScopeBoxRow[];
  scopeBoxSentences: string[];
  findings: IntroFinding[];
  wastewaterState: WastewaterIntroState;
  unusualResidentDenominator: boolean;
  electricityLooksLikeFill: boolean;
  missingCurrentYearTotal: boolean;
  wordCount: number;
  communityTotal: ClaimValue<number>;
  population: ClaimValue<number>;
  perResident: ClaimValue<number>;
  wastewater: ClaimValue<number>;
}

export const ACCOUNTING_LENS_LABEL = 'Community inventory' as const;
